import { createContext, createRef } from 'react';
import type { CompareResponse } from '@/app/api/search/compare/createCompareData.ts';
import { LAYOUT_TYPE } from '@/app/components/search/components/LayoutManager/utils.ts';
import { noop } from '../../Utilities.ts';
import type { DealToCompare } from './index.tsx';
import type { HandleWaitingCallFinished } from '../../common/waitingCallGeneric.ts';

export type SearchPageContextType = {
  listView: boolean | null;
  layoutType: LAYOUT_TYPE;
  dealsToCompare: DealToCompare[];
  canShowComparisonPromo: boolean;
  setCanShowComparisonPromo: React.Dispatch<React.SetStateAction<boolean>>;
  handleDealCompareAddClicked: (hotelId: number) => void;
  handleDealCompareRemoveClicked: (hotelId: number) => void;
  handleCompareCallFinished: ({ response }: HandleWaitingCallFinished<CompareResponse>) => void;
  showTaxesIncludedTooltip: boolean;
  triggerTaxesIncludedTooltip: () => void;
  dismissTaxesIncludedTooltip: () => void;
  taxesIncludedTooltipClaimedRef: React.RefObject<boolean>;
};

export const SearchPageContext = createContext({
  listView: false,
  layoutType: LAYOUT_TYPE.MOBILE_LIST,
  dealsToCompare: [],
  canShowComparisonPromo: false,
  setCanShowComparisonPromo: noop,
  handleDealCompareAddClicked: noop,
  handleDealCompareRemoveClicked: noop,
  handleCompareCallFinished: noop,
  showTaxesIncludedTooltip: false,
  triggerTaxesIncludedTooltip: noop,
  dismissTaxesIncludedTooltip: noop,
  taxesIncludedTooltipClaimedRef: createRef<boolean>() as React.RefObject<boolean>,
} as SearchPageContextType);
